import { render, staticRenderFns } from "./stuJobHunt.vue?vue&type=template&id=a680b3a4&scoped=true"
import script from "./stuJobHunt.vue?vue&type=script&lang=js"
export * from "./stuJobHunt.vue?vue&type=script&lang=js"
import style0 from "./stuJobHunt.vue?vue&type=style&index=0&id=a680b3a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a680b3a4",
  null
  
)

export default component.exports